module.exports = __webpack_public_path__ + "img/sys-map.06fa71d0.jpg";